export default __webpack_public_path__ + "static/media/Året jag slutade prestera och började onanera_inspelningstekniker_2021.49b2c212.jpeg";